// extracted by mini-css-extract-plugin
export default {"table":"FaU9YILXDr54er2d6bkL","emptyContainer":"X_BJNd4PU2frUQrfY0Q7"};